(function () {
    'use strict';

    angular
        .module('app.region')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'region',
                config: {
                    url: '/region',
                    abstract: true,
                    template: '<ui-view/>',
                    ncyBreadcrumb: {
                        label: 'Region'
                    },
                    data: {
                        permissions: {
                            only: [''],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            },
            {
                state: 'region.dashboard',
                config: {
                    url: '/dashboard',
                    templateUrl: 'app/region/dashboard/region.dashboard.html',
                    controller: 'RegionDashboardController',
                    controllerAs: 'vm',
                    title: 'Region Management',
                    settings: {
                        isVisible: true,
                        nav: 3,
                        content: '<i class="fa fa-globe"></i> Region Management'
                    }
                }
            }
        ];
    }
})();
